import StatementPage from "components/pages/StatementPage";

export default function CaptureEStatementsEnrollStatement(props) {
    return <StatementPage />
}